import { render, staticRenderFns } from "./FileFieldNew.vue?vue&type=template&id=38217ffa&scoped=true&"
import script from "./FileFieldNew.vue?vue&type=script&lang=js&"
export * from "./FileFieldNew.vue?vue&type=script&lang=js&"
import style0 from "./FileFieldNew.vue?vue&type=style&index=0&id=38217ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38217ffa",
  null
  
)

export default component.exports